export default __webpack_public_path__ + "static/american_life-513ab07d41781c754781b19385eb5612.svg";